<template>
    <section v-if="checkTkn()">
        <v-card
            class="formCard"
            elevation="20"
        >
            <v-alert
                v-show="snackbar"
                v-model="snackbar"
                transition="scroll-x-reverse-transition"
                style="position: fixed; z-index: 2; transform: translate(-50%, -50%); left: 50%; top: 48px;"
                :color="snackColor"
                :type="snackColor"
            >
                {{ snackText }}
            </v-alert>
            <p class="signupHeader sarabun-thin">
                HMI Provider Signup
            </p>
            <p class="signupSubHeader">
                Please fill in the details below to create your account.
            </p>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                :disabled="disableForm"
                @submit.prevent="validate"
            >
                <v-text-field
                    v-model.trim="username"
                    class="fieldDivider"
                    label="Create Username"
                    clearable
                    color="green accent-4"
                    :rules="usernameRules"
                />
                <v-text-field
                    v-model="password"
                    class="fieldDivider"
                    label="Create Password"
                    clearable
                    color="green accent-4"
                    :rules="passwordRules.concat([v=>/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(v) || 'Must contain uppercase, lowercase and number and at least 8 characters'])"
                    :append-icon="showPass.new ? mdiEye : mdiEyeOff"
                    :type="showPass.new ? 'text' : 'password'"
                    @click:append="showPass.new = !showPass.new"
                />
                <v-text-field
                    v-model="confirmPassword"
                    class="fieldDivider"
                    label="Retype Password"
                    clearable
                    color="green accent-4"
                    :rules="confirmPasswordRules.concat([password === confirmPassword || 'Password must match'])"
                    :append-icon="showPass.retype ? mdiEye : mdiEyeOff"
                    :type="showPass.retype ? 'text' : 'password'"
                    @click:append="showPass.retype = !showPass.retype"
                />
                <div
                    class="fieldDivider"
                    style="width: 100%; height: 100px; position: relative"
                >
                    <v-checkbox
                        v-model="confirmTerms"
                        style="margin: 0; padding: 0; position: absolute; top: 0; width: 10%;"
                        hide-details
                        :rules="[v => !!v || 'Agree is required']"
                        color="green accent-4"
                    />
                    <div
                        style="cursor: pointer; position: absolute; top: 0; right: 0; width: 90%;height:100px; overflow-x:hidden;  overflow-y:scroll; padding-right:5%;"
                        @click="confirmTerms = !confirmTerms"
                    >
                        <div style="font-size: 13px; font-weight: 700;">
                            I acknowledge that I have read, understood and/or have been duly informed of the <a
                                href="https://www.hmi.com.ph/data-privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style="color:green"
                            >Data Privacy Statement</a> pertaining to the data privacy practices of HMI. I hereby express my full conformity thereto.
                        </div>
                    </div>
                </div>
                <v-btn
                    color="green accent-4 white--text"
                    class="submitBtn"
                    :disabled="!valid || disableForm"
                    type="validate"
                >
                    Submit
                </v-btn>
                <!-- <v-snackbar
                    v-model="snackbar"
                    :timeout="timeout"
                    bottom
                    :color="snackColor"
                    center
                    text
                    elevation="24"
                >{{ snackText }}
                    <template v-slot:action="{ attrs }">
                        <v-btn
                            bottom
                            :color="snackColor"
                            right
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                        >
                        Close
                        </v-btn>
                    </template>
                </v-snackbar> -->
            </v-form>
        </v-card>
    </section>
</template>

<script>
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'

export default {
    data: ()=>({
        mdiEye, mdiEyeOff,
        showPass: {
            new: false,
            retype: false
        },
        successMessage: 'Success! Redirecting to Login... ',
        valid: false,
        snackText: '',
        snackColor: 'error',
        token: null,
        snackbar: false,
        username: '',
        password: '',
        confirmTerms: '',
        confirmPassword: '',
        usernameRules: [
            v => !!v || 'Username is required',
            v => v.length >= 5 || 'Username too short. Please enter at least 5 characters',
            v => !/\s/.test(v) || 'Username must not contain spaces or white characters'
        ],
        passwordRules: [v => !!v || 'Password is required'],
        confirmPasswordRules: [v => !!v || 'Retype Password is required'],
        disableForm: false
    }),
    computed: {
        ...mapGetters(['isPRoviderValid'])
    },
    watch: {
        isPRoviderValid(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (newVal.STATUS === 201) {
                    this.disableForm    = true
                    this.snackColor     = 'success'
                } else {
                    setTimeout(()=>{ this.snackbar = false }, 3000)
                    this.snackColor = 'error'
                }
                this.snackText = newVal.STATUS === 201 ? this.successMessage : newVal.STATE
                this.snackbar = true
                if (newVal.STATUS === 201) {
                    let counter = 4
                    const originalMessage = this.successMessage
                    const updateMsg = setInterval(() => {
                        this.successMessage = `${originalMessage} (${counter})`
                        this.snackText      = this.successMessage
                        counter = counter - 1
                        if (counter === 0) clearInterval(updateMsg)
                    }, 1000)
                    setTimeout(() => {
                        this.$router.push('/provider/info')
                    }, 5000)
                }
            }
        }
    },
    methods: {
        ...mapActions(['getCsrfToken','validateProvider']),
        checkTkn() {
            this.token = this.$route.query.tkn
            return true
        },
        async validate() {
            if (this.$refs.form.validate()) {
                await this.validateProvider({ USERNAME: this.username, PASSWORD: this.password, TOKEN: this.token })
            }
        }
    }
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap'); */
.sarabun-thin {
    font-family: "Mulish", sans-serif;
    font-optical-sizing: auto;
    font-weight: 600;
    font-style: normal;
    color: #000;
    font-size: 39px;
}
section {
  height: 100%;
  background-image: url("../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
  padding-top: 20px;
}
    .formCard {
        margin: 0 auto;
        width: 417px;
        background-color: white;
        padding: 20px;
        border-radius: 5px;
    }
        .fieldDivider {
            margin-bottom: 15px;
        }
        .signupHeader {
            /* text-shadow: 1px 1px 2px black; */
            width: 100%;
            margin: 0 auto 20px auto;

            text-align: center;
        }
        .signupSubHeader {
            margin: 0 auto 10px auto;
        }
        .signupFooter {
            margin-top: 8px;
        }
        .submitBtn {
            width: 100%;
        }
</style>
